import userService from './user.service'
import baseHttpService from './base.http.service'
import {router} from '../router';
import {Capacitor} from "@capacitor/core";
import Helper from "./helper.service";
import ServiceResponseCode from "../models/service.response.code";

let redirectingToLogin = false

async function redirectToLoginUnauthorized(message) {

  if (redirectingToLogin)
    return

  redirectingToLogin = true

  try {

    userService.setLoginMessage(message)
    userService.destroyUser()

    try {
      swalLoading?.close?.()
      Swal?.close?.()
    } catch (e) {
      // ignore close errors
    }

    const currentPath = (router.currentRoute?.value?.path || router.currentRoute?.path || '').toLowerCase()
    if (currentPath !== '/login') {
      await router.replace('/login')
    }

  } finally {
    setTimeout(() => {
      redirectingToLogin = false
    }, 2000)
  }

}

function isTokenAccessError(result) {
  return !result?.Success
    && Number(result?.HttpCode) === 401
    && Number(result?.Code) === ServiceResponseCode.TokenAccess
}

export default {
  async executeTokenMethod(url, method, body, timeout) {

    const user = userService.getLocalUser();

    if (body !== undefined) {
      body['Localizacao'] = Helper.currentLocale();
    } else {
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}Localizacao=${Helper.currentLocale()}`;
    }

    if (method != 'GET' && body !== undefined) {
      body['Plataforma'] = Capacitor.getPlatform() ?? 'web'
    }

    if (!url || url == undefined) throw new Error("Url não passada");
    if (!method || method == undefined) throw new Error("Método não passado");

    if (!user || !user.accessToken) {
      await redirectToLoginUnauthorized("Sessão não encontrada, entre novamente com a sua conta")
      throw new Error("Sessão não encontrada, entre novamente com a sua conta|auth-redirect")
    }

    const result = await baseHttpService.executeAPI(url, method, body, {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + user.accessToken,
      "Localizacao": Helper.currentLocale(),
      "X-Client-UUID": Helper.getClientUUID()
    }, timeout);

    if (!result.Success && result.Exception)
      console.error('API Exeption, message: ', result.Message)

    if (isTokenAccessError(result)) {
      await redirectToLoginUnauthorized(result.Message || 'Não autorizado, faça o login novamente')
      return {
        ...result,
        Type: 'auth-redirect',
      }
    }

    if (!result.Success && result.HttpCode == 401 && result.Code == 5) {
      swalToast.fire('Acesso Negado', result.Message, 'warning')
    }

    return result;

  },
  async executeUploadMethod(url, method, formData, timeout) {

    const user = userService.getLocalUser();

    if (!url || url == undefined) throw new Error("Url não passada");
    if (!method || method == undefined) throw new Error("Método não passado");

    if (!user || !user.accessToken) {
      await redirectToLoginUnauthorized("Sessão não encontrada, entre novamente com a sua conta")
      throw new Error("Sessão não encontrada, entre novamente com a sua conta|auth-redirect")
    }

    const result = await baseHttpService.executeUploadAPI(url, method, formData, {
      'Authorization': 'Bearer ' + user.accessToken,
      "X-Client-UUID": Helper.getClientUUID()
    }, timeout);

    if (isTokenAccessError(result)) {
      await redirectToLoginUnauthorized(result.Message || 'Não autorizado, faça o login novamente')
      return {
        ...result,
        Type: 'auth-redirect',
      }
    }

    return result;

  },
  async executeAnonymousMethod(url, method, body) {
    const result = await baseHttpService.executeAPI(url, method, body, {
      "Content-Type": "application/json",
      "X-Client-UUID": Helper.getClientUUID()
    });
    return result;
  },
  async executeExternalMethod(url) {
    const result = await baseHttpService.executeExternal(url, "GET", {
      "Content-Type": "application/json"
    });
    return result;
  },
  async executeDownloadBlobMethod(url, method) {

    const user = userService.getLocalUser();

    if (!user || !user.accessToken) {
      await redirectToLoginUnauthorized("Sessão não encontrada, entre novamente com a sua conta")
      throw new Error("Sessão não encontrada, entre novamente com a sua conta|auth-redirect")
    }

    const result = await baseHttpService.executeDownloadBlob(url, method, {
      'Content-Type': 'application/pdf',
      'Authorization': 'Bearer ' + user.accessToken,
      "X-Client-UUID": Helper.getClientUUID()
    });
    return result;

  },
};
